import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { environment } from 'src/environments/environment';

import { DataSharingService, RestService, StorageService } from 'src/app/_core/services';
import { HttpParamService } from 'src/app/_core/services/api/http-param.service';
import { Observable } from 'rxjs';
import { POST_GatewayModel, Put_StoreSettingsInterface, RestResponse } from 'src/app/_shared/models';
import { HttpParamsInterface } from 'src/app/_shared/interfaces/http-params.interface';
import { POST_BillingRunOperationInterface, POST_PaymentRunOperationInterface } from 'src/app/_shared/interfaces/advanced-settings-operations.interface';

const APIEndpoint: string = environment.APIEndpoint;
const APIVersion: string = environment.APIVersion;

const APIResourceChannels: string = '/channels';
const APIResourceCompanies: string = '/companies';
const APIResourceTaxRegions: string = '/tax/regions';
const APIResourceTaxesCode: string = '/tax/codes';
const APIResourceTaxNewAccount: string = '/tax/new-account';
const APIResourceSettings: string = '/settings';
const APIResourceGateways = '/gateways';
const APIResourceSmartRouting = '/smart_routing';
const APIResourceProfile: string = '/profile';
const APIResourceGatewaysOAuth = '/gateways/oauth';
const APIResourcePaymentRuns: string = '/payment-run';
const APIResourceTemplates = '/templates';
const APIResourceTypes = '/types';
const APIResourceGlobals: string = '/globals';
const APIResourceEvents: string = '/events';
const APIResourceNotifications: string = '/notifications';
const APIResourceLogs: string = '/logs';
const APIResourceBillRuns: string = '/bill-run';
const APIResourceApiCredentials: string = '/api-token';
const ApiResourceWebhooks: string = '/webhooks';
@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  private subscription: Subscription;
  private serviceUrl_TaxRegions: string;
  private serviceUrl_TaxCodeSearch: string;
  private serviceUrl_TaxNewAccount: string;
  private serviceUrl_CompanySettings: string;
  private serviceUrl_EntityGateways: string;
  private serviceUrl_EntityGatewaysMerchantId: string;
  private serviceUrl_EntitySmartRouting: string;
  private serviceUrl_CompanyProfile: string;
  private serviceUrl_GatewaysOAuth: string;
  private serviceUrl_PaymentRuns: string;
  private serviceUrl_Templates: string;
  private serviceUrl_EntitySettingsTypes: string;
  private serviceUrl_EntitySettings: string;
  private serviceUrl_Events: string;
  private serviceUrl_EventsLogs: string;
  private serviceUrl_Notifications: string;
  private serviceUrl_Channels_global: string;
  private serviceUrl_Channels: string;
  private serviceUrl_BillRuns: string;
  private serviceUrl_CompanyApiCredentials: string;
  private serviceUrl_Webhooks: string;

  constructor(private httpParamService: HttpParamService,
    private _shareData: DataSharingService,
    private _storage: StorageService,
    private _rest: RestService) {

      let entityId: string;

      this.subscription = this._shareData.currentCompany.subscribe(data => {
        if (data.companyId){
          entityId = `/${data.companyId}`;
        } else {
          entityId = `/${this._storage.readLocalStorage('entityId')}`;
        }

      // TAX REGIONS
      // /companies/{{companyId}}/tax/regions
      this.serviceUrl_TaxRegions = APIEndpoint + APIVersion + APIResourceCompanies + entityId + APIResourceTaxRegions;

      // TAXES
      // /companies/{{companyId}}/tax
      this.serviceUrl_TaxCodeSearch = APIEndpoint + APIVersion + APIResourceCompanies + entityId + APIResourceTaxesCode;

      // TAX NEW ACCOUNT
      // /companies/{{companyId}}/tax/new-account
      this.serviceUrl_TaxNewAccount = APIEndpoint + APIVersion + APIResourceCompanies + entityId + APIResourceTaxNewAccount;

            // COMPANY SETTINGS
      // /companies/{{companyId}}/settings
      this.serviceUrl_CompanySettings = APIEndpoint + APIVersion + APIResourceCompanies + entityId + APIResourceSettings;


      // PAYMENT GATEWAYS
      // https://devapi.rebillia.com/internal/companies/{{companyId}}/gateways
      this.serviceUrl_EntityGateways = APIEndpoint + APIVersion + APIResourceCompanies + entityId + APIResourceGateways;

      // SMART ROUTING
      // https://devapi.rebillia.com/internal/companies/{{companyId}}/smart_routing
      this.serviceUrl_EntityGatewaysMerchantId = APIEndpoint + APIVersion + APIResourceCompanies + entityId + APIResourceSmartRouting;

      // [POST]SMART ROUTING
      // https://devapi.rebillia.com/internal/companies/{{companyId}}/gateways/smart_routing
      this.serviceUrl_EntitySmartRouting = APIEndpoint + APIVersion + APIResourceCompanies + entityId + APIResourceGateways + APIResourceSmartRouting;

      // COMPANY
      // [GET][PUT] Company Profile
      // /companies/{{companyId}}/profile
      this.serviceUrl_CompanyProfile = APIEndpoint + APIVersion + APIResourceCompanies + entityId + APIResourceProfile;

      // GATEWAYS OAUTH CONNECT
      // https://devapi.rebillia.com/internal/companies/{{companyId}}/gateways/oauth/connect
      this.serviceUrl_GatewaysOAuth = APIEndpoint + APIVersion + APIResourceCompanies + entityId + APIResourceGatewaysOAuth;

      // PAYMENT RUNS
      // [GET] Company Payment Run
      // /companies/{{companyId}}/payment-run
      this.serviceUrl_PaymentRuns = APIEndpoint + APIVersion + APIResourceCompanies + entityId + APIResourcePaymentRuns;

      // COMPANY EMAIL TEMPLATES
      // https://devapi.rebillia.com/internal/companies/{{companyId}}/templates
      this.serviceUrl_Templates = APIEndpoint + APIVersion + APIResourceCompanies + entityId + APIResourceTemplates;

      // COMPANY SETTINGS
      // https://devapi.rebillia.com/internal/companies/{{companyId}}/settings
      this.serviceUrl_EntitySettings = APIEndpoint + APIVersion + APIResourceCompanies + entityId + APIResourceSettings;

      // https://devapi.rebillia.com/internal/companies/{{companyId}}/settings/types
      this.serviceUrl_EntitySettingsTypes = APIEndpoint + APIVersion + APIResourceCompanies + entityId + APIResourceSettings + APIResourceTypes;

      // Events
      // /globals/events
      this.serviceUrl_Events = APIEndpoint + APIResourceGlobals + APIResourceEvents;

      // NOTIFICATIONS
      // /companies/{{companyId}}/notifications
      this.serviceUrl_Notifications = APIEndpoint + APIVersion + APIResourceCompanies + entityId + APIResourceNotifications;

      // Channels
      // /globals/channels
      this.serviceUrl_Channels_global = APIEndpoint + APIResourceGlobals + APIResourceChannels;

      // CHANNELS
      // [GET] Company Channels
      // /companies/{{companyId}}/channels
      this.serviceUrl_Channels = APIEndpoint + APIVersion + APIResourceCompanies + entityId + APIResourceChannels

      // LOGS
      // /companies/{{companyId}}/logs
      this.serviceUrl_EventsLogs = APIEndpoint + APIVersion + APIResourceCompanies + entityId + APIResourceLogs;


      // BILL RUNS
      // [GET] Company Bill Run
      // /companies/{{companyId}}/bill-run
      this.serviceUrl_BillRuns = APIEndpoint + APIVersion + APIResourceCompanies + entityId + APIResourceBillRuns;

      // COMPANY API-TOKEN
      // [GET][PUT] Company API Credentials
      // /companies/{{companyId}}/api-token
      this.serviceUrl_CompanyApiCredentials = APIEndpoint + APIVersion + APIResourceCompanies + entityId + APIResourceApiCredentials;

      this.serviceUrl_Webhooks = APIEndpoint + APIVersion + APIResourceCompanies + entityId + ApiResourceWebhooks;

    });
  }

  public getTaxRegionsByCompany(): Observable<RestResponse> {
    return this._rest.get(`${this.serviceUrl_TaxRegions}`);
  }

  public getTaxesByTaxId(taxRegionISO: string): Observable<RestResponse> {
    return this._rest.get(`${this.serviceUrl_TaxRegions}/${taxRegionISO}`);
  }

  public deleteCompanyTaxRegion(taxId: number): Observable<RestResponse> {
    return this._rest.delete(`${this.serviceUrl_TaxRegions}/${taxId}`);
  }

  public searchTaxCode(value: string): Observable<RestResponse> {
    return this._rest.get(`${this.serviceUrl_TaxCodeSearch}?filter=${value}`);
  }

  public createTaxesByRegion(collectionOfTaxRegions: any): Observable<any> {
    return this._rest.post(`${this.serviceUrl_TaxRegions}`, collectionOfTaxRegions);
  }

  public createNewTrialAccount(bodyParams: any): Observable<any> {
    return this._rest.post(`${this.serviceUrl_TaxNewAccount}`, bodyParams);
  }

  public updateStoreSettings( bodyParams: Put_StoreSettingsInterface): Observable<any> {
    return this._rest.put(`${this.serviceUrl_CompanySettings}`, bodyParams);
  }

  public getEntityGateways(): Observable<RestResponse> {
    return this._rest.get(`${this.serviceUrl_EntityGateways}`);
  }

  public getSmartRouting(): Observable<RestResponse> {
    return this._rest.get(`${this.serviceUrl_EntityGatewaysMerchantId}`);
  }

  public createSmartRouting(bodyParams: any): Observable<any> {
    return this._rest.post(this.serviceUrl_EntitySmartRouting, bodyParams);
  }

  public editSmartRouting(id: any, bodyParams: any): Observable<any> {
    return this._rest.put(this.serviceUrl_EntitySmartRouting + `/${id}`, bodyParams);
  }

  public updateSmartRoutingSetDefault(companyGatewayId: number, companyCurrencyId: number): Observable<any> {
    return this._rest.put(`${this.serviceUrl_EntitySmartRouting}/${companyGatewayId}/${companyCurrencyId}/default`);
  }

  public disengageCompanyGateway(companyGatewayId: number, companyCurrencyId: number): Observable<any> {
    return this._rest.delete(`${this.serviceUrl_EntitySmartRouting}/${companyGatewayId}/${companyCurrencyId}`);
  }

  public getCompanyProfile(): Observable<RestResponse> {
    return this._rest.get(`${this.serviceUrl_CompanyProfile}`);
  }

  public updateGateway(gatewayId: number, bodyParams: POST_GatewayModel): Observable<RestResponse> {
    return this._rest.put(`${this.serviceUrl_EntityGateways}/${gatewayId}`, bodyParams);
  }

  public getEntityGatewayByGatewayId(gatewayId: number): Observable<RestResponse> {
    return this._rest.get(`${this.serviceUrl_EntityGateways}/${gatewayId}`);
  }

  public createCompanyGateway(bodyParams: POST_GatewayModel): Observable<any> {
    return this._rest.post(`${this.serviceUrl_EntityGateways}`, bodyParams);
  }

  public getGatewayOauthConnect(gatewayId: number, gatewayEnvironment: string = ''): Observable<RestResponse> {
    return this._rest.get(`${this.serviceUrl_GatewaysOAuth}/${gatewayId}/${gatewayEnvironment}`);
  }

  public getPaymentRunByPaymentRunId(paymentRunId: number, pathParams: HttpParamsInterface, noFormat: boolean): Observable<RestResponse> {
    let params = pathParams ? this.httpParamService.buildPathParams(pathParams): null;
    return this._rest.get(`${this.serviceUrl_PaymentRuns}/${paymentRunId}/transactions`, { params: params }, noFormat);
  }

  public getPaymentOperations(pathParams: HttpParamsInterface, noFormat: boolean): Observable<RestResponse> {
    let params = pathParams ? this.httpParamService.buildPathParams(pathParams): null;
    return this._rest.get(`${this.serviceUrl_PaymentRuns}`, { params: params }, noFormat);
  }

  public updateCompanyPaymentRunByPaymentRunId(companyPaymentRunId: number, bodyParams: POST_PaymentRunOperationInterface): Observable<any> {
    return this._rest.put(`${this.serviceUrl_PaymentRuns}/${companyPaymentRunId}`, bodyParams);
  }

  public manuallyRerunCompanyPaymentRunByPaymentRunId(companyPaymentRunId: number): Observable<any> {
    return this._rest.post(`${this.serviceUrl_PaymentRuns}/${companyPaymentRunId}/manually/rerun-payment-run`, {});
  }

  public getTemplateByTemplateId(templateId: number): Observable<RestResponse> {
    return this._rest.get(`${this.serviceUrl_Templates}/${templateId}`);
  }

  public updateTemplateByTemplateId(templateId: number, bodyParams: any): Observable<RestResponse> {
    return this._rest.put(`${this.serviceUrl_Templates}/${templateId}`, bodyParams);
  }

  public getSMTPSettings(): Observable<RestResponse> {
    return this._rest.get(`${this.serviceUrl_EntitySettingsTypes}/smtp`);
  }

  public updateEmailSettings(bodyParams: any): Observable<RestResponse> {
    return this._rest.put(`${this.serviceUrl_EntitySettings}`, bodyParams);
  }

  public getGlobalSystemEventsBySubscriptionChangesSection(notificationSectionKeyName: string): Observable<any> {
    return this._rest.get(`${this.serviceUrl_Events}?section=${notificationSectionKeyName}`);
  }

  public getGlobalChannels(): Observable<any> {
    return this._rest.get(`${this.serviceUrl_Channels_global}`);
  }

  public getCompanyIntegrationsByChannelId(channelId: string): Observable<any> {
    return this._rest.get(`${this.serviceUrl_Channels}/${channelId}/integrations`);
  }

  public getNotificationByKeyName(_notificationSectionKeyName: string): Observable<any> {
    return this._rest.get(`${this.serviceUrl_Notifications}?section=${_notificationSectionKeyName}`);
  }

  public deleteChannelNotificationByChannelId(notificationId: number, _channelId: number): Observable<any> {
    return this._rest.delete(`${this.serviceUrl_Notifications}/${notificationId}/channels/${_channelId}`);
  }

  public updateNotificationByChannelId(notificationId: number, channelId: number,bodyParams: any): Observable<any> {
    return this._rest.put(`${this.serviceUrl_Notifications}/${notificationId}/channels/${channelId}`, bodyParams);
  }


  public sendNotificationByChannelId(notificationId: number, channelId: number,bodyParams: any): Observable<any> {
    return this._rest.post(`${this.serviceUrl_Notifications}/${notificationId}/channel/${channelId}/send`, bodyParams);
  }

  public createChannelNotification(bodyParams: any): Observable<any> {
    return this._rest.post(`${this.serviceUrl_Notifications}`, bodyParams);
  }

  public editChannelNotification(notificationId: any, bodyParams: any): Observable<any> {
    return this._rest.put(`${this.serviceUrl_Notifications}/${notificationId}`, bodyParams);
  }

  public getEventByEventId(eventId: number): Observable<any> {
    return this._rest.get(`${this.serviceUrl_EventsLogs}/${eventId}`)
  }

  public getEvents(pathParams: HttpParamsInterface, noFormat: boolean): Observable<RestResponse> {
    let params = pathParams ? this.httpParamService.buildPathParams(pathParams): null;
    return this._rest.get(`${this.serviceUrl_EventsLogs}`, { params: params }, noFormat);
  }

  public getDunningConfiguration(typeConfig: string): Observable<RestResponse> {
    return this._rest.get(`${this.serviceUrl_EntitySettings}/${typeConfig}`);
  }

  public updateDunningConfiguration(bodyParams: any): Observable<any> {
    return this._rest.put(`${this.serviceUrl_EntitySettings}`, bodyParams);
  }

  public getDunningConfigs(): Observable<RestResponse> {
    return this._rest.get(`${this.serviceUrl_EntitySettings}/types/dunning`);
  }

  public getBillingRunByBillingRunId(billRunId: number, pathParams: HttpParamsInterface): Observable<RestResponse> {
    let params = pathParams ? this.httpParamService.buildPathParams(pathParams): null;

    return this._rest.get(`${this.serviceUrl_BillRuns}/${billRunId}/invoices`, { params: params });
  }

  public getBillingRuns(pathParams: HttpParamsInterface, noFormat: boolean): Observable<RestResponse> {
    let params = pathParams ? this.httpParamService.buildPathParams(pathParams): null;
    return this._rest.get(`${this.serviceUrl_BillRuns}`, { params: params }, noFormat);
  }

  public updateBillRunByBillRunId(billRunId: number, bodyParams: POST_BillingRunOperationInterface): Observable<any> {
    return this._rest.put(`${this.serviceUrl_BillRuns}/${billRunId}`, bodyParams);
  }

  public billingRunExecuteNow(billRunId: number): Observable<any> {
    return this._rest.post(`${this.serviceUrl_BillRuns}/${billRunId}/run-now`, {});
  }

  public getApiKeys(noFormat: boolean): Observable<RestResponse> {
    return this._rest.get(`${this.serviceUrl_CompanyApiCredentials}`, noFormat);
  }

  public createApiKeys(): Observable<RestResponse> {
    return this._rest.post(`${this.serviceUrl_CompanyApiCredentials}`, {});
  }

  public paymentRunExecuteNow(paymentRunId: number): Observable<any> {
    return this._rest.post(`${this.serviceUrl_PaymentRuns}/${paymentRunId}/run-now`, {});
  }

  public deleteWebhook(id): Observable<any> {
    return this._rest.delete(`${this.serviceUrl_Webhooks}/${id}`);
  }

  public getWebhooks(): Observable<any> {
    return this._rest.get(`${this.serviceUrl_Webhooks}/`);
  }

  public newWebhook(data): Observable<any> {
    return this._rest.post(`${this.serviceUrl_Webhooks}`, data);
  }
  public editWebhook(id, data): Observable<any> {
    return this._rest.put(`${this.serviceUrl_Webhooks}/${id}`, data);
  }
  public getWebhookById(id): Observable<any> {
    return this._rest.get(`${this.serviceUrl_Webhooks}/companyWebhook/${id}`);
  }
  public testRblTrigger(id): Observable<any> {
    return this._rest.post(`${this.serviceUrl_Webhooks}/rbl-webhook-trigger/${id}/test`,{});
  }
  public testCompanyWebhookTrigger(webhookId, id): Observable<any> {
    return this._rest.post(`${this.serviceUrl_Webhooks}/${webhookId}/triggers/${id}/test`,{});
  }

  public testTrigger(id): Observable<any> {
    return this._rest.post(`${this.serviceUrl_Webhooks}/triggers/${id}/test`,{});
  }
  public getTriggerLogs(id): Observable<any> {
    return this._rest.get(`${this.serviceUrl_Webhooks}/${id}/logs`);
  }
  public getLogById(id): Observable<any> {
    return this._rest.get(`${this.serviceUrl_Webhooks}/logs/${id}`);
  }

  public getWebhookTriggers(): Observable<any> {
    return this._rest.get(`${this.serviceUrl_Webhooks}/triggers`);
  }
  getLanguage(){
    return 'de-DE';
  }
}
